<template>
<div>
  <div class="title fixed">本月回顾</div>
  <div class="holder"></div>
  <div class="context">
    <el-calendar v-model="calendarDate">
      <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
      <template
          v-slot:dateCell="{date}">
        <div class="score-cell">
          <div v-if="recordDataMap[formatDate(date)]" class="background-indicator plus"
               :style="{height:`${clamp(recordDataMap[formatDate(date)].positive_score/expectedScore,0.01,1)*100}%`}"></div>
          <div v-if="recordDataMap[formatDate(date)]" class="background-indicator minus"
               :style="{height:`${clamp(-recordDataMap[formatDate(date)].negative_score/expectedScore,0.01,1)*100}%`}"></div>
          <div class="date">{{date.getDate()}}</div>
          <div v-if="recordDataMap[formatDate(date)]">
            <div class="detail plus">+<span>{{recordDataMap[formatDate(date)].positive_score}}</span></div>
            <div class="detail minus">- <span>{{-recordDataMap[formatDate(date)].negative_score}}</span></div>
          </div>
        </div>
      </template>
    </el-calendar>
  </div>
</div>
</template>

<script>
import {formatDateTime,formatDate,formatMonth, timeAgo} from "@/util/time";
import {getScoreSumOfCurrentMonth} from "@/api/api";

export default {
  name: "HistoryRecord",
  data(){
    return {
      calendarDate:new Date(),
      recordData:[],
      lastDate:'',
      expectedScore:15,
    }
  },
  mounted() {
    this.getScoreSumOfCurrentMonth(formatDate(new Date()))
  },
  computed:{
    recordDataMap(){
      return this.recordData.reduce((t,c)=>{
        t[formatDate(c.date)]={
          positive_score:c.positive_score,
          negative_score:c.negative_score
        }
        return t
      },{})
    }
  },
  watch:{
    calendarDate(val){
      if(formatMonth(val)!==formatMonth(this.lastDate)){
        this.getScoreSumOfCurrentMonth(formatDate(val))
      }
    }
  },

  methods:{
    formatDateTime,timeAgo,formatDate,
    getScoreSumOfCurrentMonth(date){
      this.lastDate=date
      getScoreSumOfCurrentMonth({date:date}).then(res=>{
        console.log(res)
        this.recordData=res.data
      }).catch(err=>{
        console.log(err)
      })
    },
    clamp(val, min, max) {
      return Math.min(Math.max(val, min), max)
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  top:0;
  font-size: 26px;
  height: 60px;
  line-height: 60px;
  width: 100%;
  background-color: white;
  z-index: 1;
}
.fixed{
  position: fixed;
}
.holder{
  height: 60px;
}
.context{
}
.score-cell{
  position: relative;
  height: 100%;
  .background-indicator{
    position: absolute;
    bottom: 0;
    width: 50%;
    z-index: 0;
    &.plus{
      background-color: #42b98366;
      left: 0;
    }
    &.minus{
      right: 0;
      background-color: #eb4b4baa;
    }
  }
  .detail{
    font-size: 12px;
    &.plus{
      color: #42b983;
    }
    &.minus{
      color: darkred;
    }
  }
}
</style>